import { __awaiter, __generator } from "tslib";
import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createCommentVNode as _createCommentVNode } from "vue";
var _hoisted_1 = { class: "platform-page pt-5" };
var _hoisted_2 = { class: "text-center" };
var _hoisted_3 = { class: "text-center text-white availables" };
var _hoisted_4 = { class: "groups-list row justify-content-center" };
var _hoisted_5 = { class: "card" };
var _hoisted_6 = { class: "card-body" };
var _hoisted_7 = { class: "d-flex justify-content-center align-items-center" };
var _hoisted_8 = { class: "group-name-wrapper" };
var _hoisted_9 = { class: "" };
var _hoisted_10 = { class: "price" };
var _hoisted_11 = { class: "expiration text-center" };
var _hoisted_12 = { key: 0 };
var _hoisted_13 = { key: 1 };
var _hoisted_14 = { class: "text-center" };
var _hoisted_15 = { class: "card-footer" };
var _hoisted_16 = { class: "d-flex justify-content-center" };
var _hoisted_17 = ["onClick"];
import { ref, onMounted } from 'vue';
import { viewPlatform } from '@/api/admin/platforms';
import { notify } from '@/utils/toast';
import { useAuthStore } from '@/stores/authStore';
import { useRouter } from 'vue-router';
import { toast } from 'vue3-toastify';
import { dateFormat } from '@/utils/dateformat';
export default /*@__PURE__*/ _defineComponent({
    __name: 'PlatformPage',
    setup: function (__props) {
        var _this = this;
        var platform = ref([]);
        var router = useRouter();
        var auth = useAuthStore();
        onMounted(function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, loadGroups()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); });
        var loadGroups = function () { return __awaiter(_this, void 0, void 0, function () {
            var currentId, response, _a, error_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 5, , 6]);
                        currentId = router.currentRoute.value.params.id;
                        return [4 /*yield*/, viewPlatform(currentId)];
                    case 1:
                        response = _b.sent();
                        if (!(response.status === 200)) return [3 /*break*/, 3];
                        _a = platform;
                        return [4 /*yield*/, response.data.record];
                    case 2:
                        _a.value = _b.sent();
                        console.log(platform.value, response.data);
                        return [3 /*break*/, 4];
                    case 3:
                        notify('Error al cargar los grupos', 'danger', toast.POSITION.BOTTOM_CENTER);
                        _b.label = 4;
                    case 4: return [3 /*break*/, 6];
                    case 5:
                        error_1 = _b.sent();
                        notify('Error al cargar los grupos', 'danger', toast.POSITION.BOTTOM_CENTER);
                        return [3 /*break*/, 6];
                    case 6: return [2 /*return*/];
                }
            });
        }); };
        var subscribe = function (gr) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                auth.addOrder(gr.id);
                if (!auth.isAuthenticated) {
                    notify('Debes iniciar sesión para suscribirte', 'warning', toast.POSITION.BOTTOM_CENTER);
                    router.push({ name: 'Login' });
                }
                else {
                    router.push({ name: 'Order' });
                }
                return [2 /*return*/];
            });
        }); };
        return function (_ctx, _cache) {
            var _a;
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("h1", _hoisted_2, _toDisplayString(platform.value.name), 1),
                _createElementVNode("p", _hoisted_3, [
                    _cache[0] || (_cache[0] = _createElementVNode("strong", null, "Perfiles disponibles:", -1)),
                    _createTextVNode(" " + _toDisplayString(platform.value.available_prf - platform.value.used_prf) + " / " + _toDisplayString(platform.value.available_prf), 1)
                ]),
                _createElementVNode("div", _hoisted_4, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_a = platform.value) === null || _a === void 0 ? void 0 : _a.groups, function (gr) {
                        return (_openBlock(), _createElementBlock("div", {
                            class: "group-card col-xs-12 col-md-6 col-lg-3 py-2",
                            key: gr.id
                        }, [
                            _createElementVNode("div", _hoisted_5, [
                                _createElementVNode("div", _hoisted_6, [
                                    _createElementVNode("div", _hoisted_7, [
                                        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "square-logo" }, null, -1)),
                                        _createElementVNode("div", _hoisted_8, [
                                            _createElementVNode("h3", _hoisted_9, _toDisplayString(gr.groupName), 1),
                                            _createElementVNode("h5", _hoisted_10, "$us " + _toDisplayString(gr.cost_per_account), 1)
                                        ])
                                    ]),
                                    _createElementVNode("h5", _hoisted_11, [
                                        _createTextVNode(" Vence: " + _toDisplayString(_unref(dateFormat)(gr.expiredAt, 'DD MMMM')) + " ", 1),
                                        _cache[3] || (_cache[3] = _createElementVNode("br", null, null, -1)),
                                        _createElementVNode("small", null, [
                                            _createTextVNode(" (" + _toDisplayString(gr.daysRemaining) + " ", 1),
                                            (gr.daysRemaining > 1)
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_12, "días"))
                                                : (gr.daysRemaining === 1)
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_13, "día"))
                                                    : _createCommentVNode("", true),
                                            _cache[2] || (_cache[2] = _createTextVNode(" restantes) "))
                                        ])
                                    ]),
                                    _createElementVNode("p", _hoisted_14, _toDisplayString(gr.available_prf) + " perfiles disponibles", 1)
                                ]),
                                _createElementVNode("div", _hoisted_15, [
                                    _createElementVNode("div", _hoisted_16, [
                                        _createElementVNode("button", {
                                            class: "btn btn-primary text-uppercase fw-bold text-white",
                                            onClick: function ($event) { return (subscribe(gr)); }
                                        }, "Suscribirme", 8, _hoisted_17)
                                    ])
                                ])
                            ])
                        ]));
                    }), 128))
                ])
            ]));
        };
    }
});
